import { __assign, __rest } from "tslib";
import React from 'react';
import VeltMediaSourceSettingsOptionsItemWireframe from './VeltMediaSourceSettingsOptionsItemWireframe/VeltMediaSourceSettingsOptionsItemWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltMediaSourceSettingsOptionsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-options-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsOptionsWireframe.Item = VeltMediaSourceSettingsOptionsItemWireframe;
export default VeltMediaSourceSettingsOptionsWireframe;
